import { Panel, PanelType } from "@fluentui/react";
import React, { useCallback, useEffect } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import BaseTelelirk from "../../../../components/generic/baseTelerik";
import AuthService from "../../../../services/authService";
import { CLAIM_PERSONA_ID } from "../../../../utils/helpers/roleHelpers";
interface IPanelReporteTelerik {
  isOpen: boolean;
  onDismiss: () => void;
}

export const PanelReporteTelerik = (props: IPanelReporteTelerik) => {

  function obtenerUsuario() {
    return AuthService.getInfoToken(CLAIM_PERSONA_ID);
  }

  const onRenderHeaderPanel = useCallback(
    () => (
      <>
        <PanelHeader
          key={"agregar"}
          nameIconHeader="filter"
          subTextHeader="Reporte Histórico ChekList Equipo Trabajo"
          textHeader="Reporte Histórico"
        />
      </>
    ),
    []
  );

  return (
    <div>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        onRenderHeader={onRenderHeaderPanel}
        isFooterAtBottom={true}
        closeButtonAriaLabel="Close"
        type={PanelType.large}
        isLightDismiss
      >
        <BaseTelelirk
          reportName="ChecklistReporteHistoricoSupervisor.trdx"
          parametros={{
            supervisorId: obtenerUsuario(),
          }}
        />
      </Panel>
    </div>
  );
};
